import { StockQuantityLocationColumns } from 'features/inventory/locations/stock-quantity-locations';
import { EnhancedCard } from 'components/enhanced/card/EnhancedCard';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { IsSuperAdminGuard } from 'shared/permissions/IsSuperAdmin';
import { useIsTechnician } from 'shared/permissions/useIsTechnician';
import { useIsTechnicianCoordinator } from 'shared/permissions/useIsTechnicianCoordinator';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Option } from 'shared/types/general';
import toast from 'shared/utils/toast';
import LocationForm from '../components/LocationForm';
import { Location } from '../types';
import { stockQuantityLocationService } from 'features/inventory/stock/api/stock-quantity-location.service';
import { locationService, productService } from 'shared/services';

export function EditLocation() {
  const translationPrefix = 'pages.locations.edit';
  const { locationId } = useParams();

  const isDisabled = useIsTechnicianCoordinator() || useIsTechnician();

  const { t } = useTranslation();

  const [location, setLocation] = useState<Location>();
  const [products, setProducts] = useState<Option[]>([]);

  useEffect(() => {
    if (locationId) {
      locationService.get(+locationId).then(setLocation);
      productService.getAllBaseInformation().then(setProducts);
    }
  }, []);

  const updateLocation = async (values) => {
    const res = await locationService.add(values);
    if (res.id) {
      setLocation(res);
      toast.crud.successUpdate('Piazza', 'f');
    }
  };

  const isAdmin = IsSuperAdminGuard();
  const columnsStockQuantityLocation = StockQuantityLocationColumns(isAdmin);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={location?.code}>
      <EnhancedCard title={t('global.base-info-form')}>
        {location && (
          <LocationForm location={location} onSubmit={updateLocation} disableEdit={isDisabled} />
        )}
      </EnhancedCard>
      <EnhancedCard title={t(`${translationPrefix}.stock-list-menu`)}>
        {location && (
          <EnhancedDataGrid
            service={stockQuantityLocationService}
            columns={columnsStockQuantityLocation}
            outerParams={{ location: location.id }}
            disableDelete
            disableEdit={isDisabled}
          />
        )}
      </EnhancedCard>
    </TenantPage>
  );
}

export default EditLocation;
